exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1500px){.container-fluid[data-v-189928f2]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-189928f2]{width:60%}}.lnk[data-v-189928f2]{cursor:pointer}.centered-and-cropped[data-v-189928f2]{object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-189928f2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cilinders/CilinderIntro.vue
// module id = 160
// module chunks = 0